export { default } from './ContactMap';
